import { render, staticRenderFns } from "./deviceAllocationList.vue?vue&type=template&id=23878da6"
import script from "./deviceAllocationList.vue?vue&type=script&lang=js"
export * from "./deviceAllocationList.vue?vue&type=script&lang=js"
import style0 from "./deviceAllocationList.vue?vue&type=style&index=0&id=23878da6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports